import { ServiceSettingSanctionStore } from './service-setting-sanction.store';
import { fb } from '../../../../../../../../packages/client/src/app/modules/shared/shared.global-service';
import { Component, inject } from '@angular/core';
import { SERVICE_SETTINGS_SANCTION_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../modules/content/components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-setting-sanction',
    templateUrl: './service-setting-sanction.component.html',
    styleUrl: './service-setting-sanction.component.scss',
    providers: [ServiceSettingSanctionStore],
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingSanctionComponent {

    public readonly store = inject(ServiceSettingSanctionStore);

    protected form = fb.group({});

    protected readonly SERVICE_SETTINGS_SANCTION_TYPE_KEY = SERVICE_SETTINGS_SANCTION_TYPE_KEY;
}
